import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin, FaWhatsapp, FaYoutube } from "react-icons/fa";
import svnLogo from '../images/svnlogo.jpg'

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-green-500 to-green-800 text-white py-10 px-5">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
        {/* Logo & About */}
        <div>
          <img
            src={svnLogo}
            alt="School Logo"
            className="w-20 mx-auto md:mx-0 rounded-full"
          />
           <p className="mt-4 text-xl text-gray-200">
           SVN Convent and English High School
          </p>
          <p className="mt-1 text-gray-200">
            Empowering students with knowledge and innovation.
          </p>
        </div>

        {/* Contact Info */}
        <div>
          <h2 className="text-xl font-bold">Contact Us</h2>
          <p className="mt-2 text-gray-200">SVN Convent and English High School, XCGC+538, Honniganahatti, Karnataka 562130</p>
          <p className="text-gray-200">Email: info@school.com</p>
          <p className="text-gray-200">Phone: +123 456 7890</p>
        </div>

        {/* Social Links */}
        <div>
          <h2 className="text-xl font-bold">Follow Us</h2>
          <div className="flex justify-center md:justify-start gap-4 mt-4">
            <a href="#" className="text-white text-2xl hover:text-gray-300">
              <FaFacebookF />
            </a>
            <a href="#" className="text-white text-2xl hover:text-gray-300">
              <FaInstagram />
            </a>
            <a href="#" className="text-white text-2xl hover:text-gray-300">
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
      
      <div className="mt-8 text-center text-gray-300 border-t border-gray-400 pt-4">
        &copy; {new Date().getFullYear()} SVN Convent and English High School. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
